import type {ResolvedWidgetInterestRate} from '../dtos';
import {wmRequest, wmUrl} from './wm-client';

export interface PaymentPlanRateIdentity {
  expectedVersion: number;
  expectedPlanFingerprint: string;
}

export const paymentPlanRateApi = {
  apply: (stepUid: string, data: PaymentPlanRateIdentity & {annualRatePct: number | null}): Promise<ResolvedWidgetInterestRate> =>
    wmRequest<ResolvedWidgetInterestRate>({url: wmUrl(`/v1/tasks/steps/${stepUid}/payment-plan/rate`), method: 'POST', data}),
  retry: (stepUid: string, data: PaymentPlanRateIdentity): Promise<ResolvedWidgetInterestRate> =>
    wmRequest<ResolvedWidgetInterestRate>({url: wmUrl(`/v1/tasks/steps/${stepUid}/payment-plan/rate/retry`), method: 'POST', data}),
};
